import React, { useEffect } from 'react';

const ResDiaryWidget = () => {



  return (
    <div id="rd-widget-frame" style={{  margin: 'auto', width: "85%", height: "100%" }}>
  
     
    </div>
  );
};

export default ResDiaryWidget;